import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SettingsService } from '../core/settings/settings.service';
import { BotService } from '../chatstyle/bot/bot.service';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

    rightPanelVisible = false;
    rightPanelUrl = 'about:blank';
    isOnboarding = false;

    constructor(
        private settings: SettingsService,
        private cdr: ChangeDetectorRef,
        private router: Router,
        private botService: BotService
    ) { }

    ngOnInit() {
        this.rightPanelVisible = this.settings.getLayoutSetting('rightPanelOpen') || false;

        // Load the right panel URL from server settings
        const serverPanelUrl = this.settings.getSetting('rightPanelUrl');
        if (serverPanelUrl) {
            this.rightPanelUrl = serverPanelUrl;
        }

        // Prime the bot once at the layout level so all authenticated child routes can
        // subscribe to botService.bot$ without each one triggering its own fetch.
        // Errors are swallowed here — pre-onboarding the bot doesn't exist yet, and
        // pages that actually need a bot can react to bot$ staying null.
        this.botService.getBot().subscribe({
            next: () => {},
            error: () => {}
        });

        // Check if we're in onboarding on initial load
        this.checkOnboardingRoute();

        // Subscribe to route changes to detect onboarding
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.checkOnboardingRoute();
        });

        // Subscribe to settings changes
        this.settings.layoutSettingsChange.subscribe((change: {key: string, value: any}) => {
            if (change.key === 'rightPanelOpen') {
                this.rightPanelVisible = change.value;
                this.cdr.detectChanges();
            }
        });
    }

    checkOnboardingRoute(): void {
        const url = this.router.url;
        this.isOnboarding = url.includes('/setup/setupwizard');
    }

    getRightPanelVisible(): boolean {
        return this.rightPanelVisible;
    }

}
